module.exports = __webpack_public_path__ + "img/icon_7.680b659b.png";